import { render, staticRenderFns } from "./ResourceConfig.vue?vue&type=template&id=1669e003&scoped=true"
import script from "./ResourceConfig.vue?vue&type=script&lang=js"
export * from "./ResourceConfig.vue?vue&type=script&lang=js"
import style0 from "./ResourceConfig.vue?vue&type=style&index=0&id=1669e003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1669e003",
  null
  
)

export default component.exports